import { defineMessages } from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'billing.invoices-table.Due Date',
        defaultMessage: 'Due Date'
    },
    billStatus: {
        id: 'billing.invoices-table.Bill Status',
        defaultMessage: 'Bill Status'
    },
    lastPaymentDate: {
        id: 'billing.invoices-table.Last Paid/Adj Date',
        defaultMessage: 'Last Paid/Adj Date'
    },
    invoiceTotal: {
        id: 'billing.invoices-table.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    paidOrAdj: {
        id: 'billing.invoices-table.Paid/Adjusted',
        defaultMessage: 'Paid/Adjusted'
    },
    paid: {
        id: 'billing.invoices-table.Paid',
        defaultMessage: 'Paid'
    },
    adjusted: {
        id: 'billing.invoices-table.Adjusted',
        defaultMessage: 'Adjusted'
    },
    outstanding: {
        id: 'billing.invoices-table.Outstanding',
        defaultMessage: 'Outstanding'
    },
    invoice: {
        id: 'billing.invoices-table.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    payInvoice: {
        id: 'billing.invoices-table.PayMinimumDue',
        defaultMessage: 'Pay Minimum Due'
    },
    payInFull: {
        id: 'billing.invoices-table.PayInFull',
        defaultMessage: 'Pay in Full'
    },
    noMatchingPayments: {
        id: 'billing.invoices-table.No matching payments.',
        defaultMessage: 'No matching payments.'
    },
    documents: {
        id: 'tdic.billing.invoices-table.Documents',
        defaultMessage: 'Documents'
    },
    viewDownload: {
        id: 'tdic.billing.invoice-summary.invoice-documents.View/Download',
        defaultMessage: 'View/Download'
    },
    downloadErrorMessage: {
        id: 'tdic.billing.invoice-summary.invoice-documents.Apologies: we are unable to access your billing documents at this time. Please try again later.',
        defaultMessage: 'Apologies: we are unable to access your billing documents at this time. Please try again later.'
    },
    invoicePolicyTypeColumn: {
        id: 'tdic.billing.invoices-table.Policy',
        defaultMessage: 'Policy'
    },
    invoiceTypeColumn: {
        id: 'tdic.billing.invoices-table.Type',
        defaultMessage: 'Type'
    },
    invoicePolicyNumberColumn: {
        id: 'tdic.billing.invoices-table.Policy Number',
        defaultMessage: 'Policy Number'
    }
});
